import React from "react";
import { ColumnValueRendererProps } from "../table.data.interface";

const TagsColumn = ({
  columnData,
  itemIds,
  isPreview,
  otherBoardsValues,
}: ColumnValueRendererProps) => {
  if (
    columnData.value === "Empty Column" ||
    (!columnData.text && isPreview) ||
    (!columnData?.value && otherBoardsValues)
  ) {
    return null;
  }

  const value = otherBoardsValues
    ? (columnData?.text as string)
    : isPreview
      ? columnData?.text
      : (columnData?.value as string);

  if (isPreview) {
    return <div>{value as string}</div>;
  }

  return <div>{value}</div>;
};

export default TagsColumn;
